import React from 'react'
import Stepper from '../shared/stepper.js'
import ModalError from '../shared/modal_errore.js'
import { connect } from 'react-redux'
import moment from 'moment';
import utils from '../../modules/utils.js'
import CTA from '../shared/cta.js'
import Spinner from '../shared/spinner.js';
import RecapArea from "../shared/recap_area.js";
import BoxFiliale from "../shared/BoxFiliale/index";
import { setFiliale, setDisponibilita, setOrario, clearHistoryBack } from "../../actions/index";
import './filiale.css'
import { handleMapOpening, stopDigitalAssistant } from "../../modules/datalayer.js"
import { trackPageView } from "../../modules/datalayer.js"
import apiInvoker from '../../modules/apiInvoker.js';
/* Flow */
import { handleFlow } from '../../flow/flow';

const mapStateToProps = (state) => {
  return {
    filiali: state.dati_locali.filiali,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    setOrario: (orario) => dispatch(setOrario(orario)),
    setFiliale: (filiale) => dispatch(setFiliale(filiale)),
    setDisponibilita: (d) => dispatch(setDisponibilita(d)),
    clearHistoryBack: (c) => dispatch(clearHistoryBack(c)),
  }
}

class Filiale extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filiali: [],
      filiali_total: [],
      filiali_selezionate: [],
      orari_caricati: [],
      nome_filiale_selezionata: "",
      indirizzo_filiale_selezionata: "",
      tentativi_rimanenti: 50,
      t: null,
      fist_disp_call: false,
      mappa_aperta: ""
    }
    this.apriFiliale = this.apriFiliale.bind(this);
    this.setDataAndGo = this.setDataAndGo.bind(this);
    this.controllaDisponibilita = this.controllaDisponibilita.bind(this);
    this.aggiornaDisponibilita = this.aggiornaDisponibilita.bind(this);
    this.getDisponibilita = this.getDisponibilita.bind(this);
    this.openMap = this.openMap.bind(this);
    this.renderFiliali = this.renderFiliali.bind(this);
  }

  componentDidMount() {
    stopDigitalAssistant();
    this.aggiornaDisponibilita();
    this.state.t = setInterval(this.controllaDisponibilita, 100);
    trackPageView('scelta-filiale');

    utils.animate.fadeIn();
    utils.animate.slideIn(utils.getState().dati_locali.historyBack);
    utils.animate.zoomIn();
  }

  filialeHasData(id) {
    let hasData = false;
    const global_state = utils.getState();
    if (global_state.dati_locali && global_state.dati_locali.filiali && global_state.dati_locali.filiali.filiali) {
      for (let f in global_state.dati_locali.filiali.filiali) {
        const filiale = global_state.dati_locali.filiali.filiali[f];
        if (filiale.idFiliale == id && filiale.disponibilita.length>0) {
          hasData = true;
        }
      }
    }
    return hasData;
  }

  renderFiliali(firstActivation = true) {
    const global_state = utils.getState();
    let tot_filiali = this.state.filiali_total.slice(0);
    let vis_filiali = this.state.filiali.slice(0);
    let count = 0;
    if (tot_filiali.length > 4) {
      let tentativi_max = 50; //Se non trova nulla in 50 disponibilit� ci arrendiamo
      while (count < 5 && tentativi_max--) {
        let da_disegnare = true;
        if (tot_filiali.length > 0) {
          for (let k = 0; k < tot_filiali[0].disponibilitaAsap.length; k++) {
            let disp = tot_filiali[0].disponibilitaAsap[k];
            let data_appuntamento = moment().format('YYYYMMDD');
            if (global_state && global_state.data_appuntamento != "") {
              data_appuntamento = moment(global_state.data_appuntamento).format('YYYYMMDD');
            }
            let giorno_disp = moment(disp.key).format('YYYYMMDD');
            if (giorno_disp == data_appuntamento && (disp.value < 0 || disp.value > 99)) {
              da_disegnare = false;
            }
          }
          if (
            da_disegnare
            //&& (global_state.flusso_modifica == false || (global_state.flusso_modifica == true && global_state.dati_locali.vecchio_appuntamento.id_filiale==))
          ) {
            vis_filiali.push(tot_filiali[0]);
            count++;
          }
        }
        tot_filiali.splice(0, 1);
      }

      this.setState({
        filiali: vis_filiali,
        filiali_total: tot_filiali,
      });

      // utils.animate.slideIn(utils.getState().dati_locali.historyBack, firstActivation);
      this.props.clearHistoryBack();
    }
  }

  renderAltreFiliali() {
    this.renderFiliali(false);
  }

  aggiornaDisponibilita() {
    const global_state = utils.getState();
    let self = this;
    const prima_filiale = (global_state.dati_locali && global_state.dati_locali.filiali && global_state.dati_locali.filiali.filiali) ? global_state.dati_locali.filiali.filiali[0] : null;
    if (prima_filiale) {
      var filiali_sel = self.state.filiali_selezionate.slice(0);
      if (filiali_sel.indexOf(prima_filiale.idFiliale) == -1) {
        filiali_sel.push(prima_filiale.idFiliale);
      }
      this.setState({
        filiali_total: global_state.dati_locali.filiali.filiali,
        filiali_selezionate: filiali_sel,
        nome_filiale_selezionata: prima_filiale.nomeFiliale,
        indirizzo_filiale_selezionata: prima_filiale.indirizzo + " - " + prima_filiale.cap + " " + prima_filiale.citta
      });

      if (self.state.filiali_total.length > 5) {
        this.renderFiliali();
      }

      if (!self.state.fist_disp_call) {
        let payload = {
          Giorno: global_state.data_appuntamento,
          CodFiliale: prima_filiale.idFiliale,
          TipoFiliali: 0
        };

        if (global_state.prodotto == 3) {
          payload = {
            ...payload,
            TipoFiliali: 1,
          };
        }
        
        self.setState({
          'fist_disp_call': true
        });
        apiInvoker.DisponibilitaFiliale(payload, disp => {
          const disponibilita = disp.data;
        
          utils.sortAvailableHours(disponibilita.orariDisponibili);
          self.props.setDisponibilita(disponibilita);

          self.syncState();
        }, err => {
          document.querySelector('.modal-error .error-text').innerText = err;
          document.querySelector('.modal-error-container').classList.add('is-modal-shown');
        });
      }
    }
  }
  controllaDisponibilita() {
    const global_state = utils.getState();
    let self = this;
    if (self.state && self.state.tentativi_rimanenti > 0) {
      if (global_state && global_state.dati_locali && global_state.dati_locali.filiali) {
        self.aggiornaDisponibilita();
        clearInterval(self.state.t);
      }
      self.state.tentativi_rimanenti--;
    } else {
      clearInterval(self.state.t);
    }
  }
  syncState() {
    const global_state = utils.getState();
    let vis_filiali = this.state.filiali;
    let self = this;
    for (let i = 0; i < vis_filiali.length; i++) {
      let filiale = vis_filiali[i];
      for (let z = 0; z < global_state.dati_locali.filiali.filiali.length; z++) {
        let filiale_globale = global_state.dati_locali.filiali.filiali[i];
        if (filiale_globale && filiale_globale.idFiliale == filiale.idFiliale) {
          vis_filiali[i] = filiale_globale;
        }
      }
    }
    let id_filiale = (vis_filiali[0] && vis_filiali[0].idFiliale) ? vis_filiali[0].idFiliale : "000";
    if (vis_filiali[0] && vis_filiali[0].disponibilita && vis_filiali[0].disponibilita.length == 0) {
      let payload = {
        Giorno: global_state.data_appuntamento,
        CodFiliale: id_filiale,
        TipoFiliali: 0
      };

      if (global_state.prodotto == 3) {
        payload = {
          ...payload,
          TipoFiliali: 1,
        };
      }
      
      apiInvoker.DisponibilitaFiliale(payload, disp => {
        const disponibilita = disp.data;

        utils.sortAvailableHours(disponibilita.orariDisponibili);
        self.props.setDisponibilita(disponibilita);
        self.syncState();
      }, err => {
        document.querySelector('.modal-error .error-text').innerText = err;
        document.querySelector('.modal-error-container').classList.add('is-modal-shown');
      });
    }
    let filiali_aperte = this.state.filiali_selezionate;
    /*if (filiali_aperte.indexOf(id_filiale)==-1) {
        filiali_aperte.push(id_filiale);
    }*/
    this.setState({
      'filiali': vis_filiali,
      'filiali_selezionate': filiali_aperte
    });
  }
  openMap(event) {
    let el = event.target;
    let filiale = el.getAttribute("data-filiale");
    if (filiale != this.state.mappa_aperta) {
      let in_lat = parseFloat(el.getAttribute("data-lat"));
      let in_lng = parseFloat(el.getAttribute("data-lng"));
      this.setState({
        'mappa_aperta': filiale
      });
      let cur_map = document.querySelector(".box_mappa[data-filiale='" + filiale + "']");
      let map = new window.google.maps.Map(cur_map, {
        center: { lat: in_lat, lng: in_lng },
        zoom: 17,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
      });

      var ic = {
        url: "./img/map-marker.png", // url
        scaledSize: new window.google.maps.Size(30, 42), // scaled size
        //origin: new window.google.maps.Point(0, 0), // origin
        //anchor: new window.google.maps.Point(0, 0) // anchor
      };

      new window.google.maps.Marker({
        position: new window.google.maps.LatLng(in_lat, in_lng),
        icon: ic,
        map: map
      });

      /* Google Tag Manager - Handle dataLayer push */
      handleMapOpening('Aperta');
      /* End Google Tag Manager - Handle dataLayer push */
    } else {
      this.setState({
        'mappa_aperta': ''
      });
      handleMapOpening('Chiusa');
    }
  }
  apriFiliale(event) {
    const global_state = utils.getState();
    const el = utils.closest(event.currentTarget, '.filiale-box')
    const id = el.getAttribute("id_filiale");
    let self = this;
    let payload = {
      Giorno: global_state.data_appuntamento,
      CodFiliale: id,
      TipoFiliali: 0
    };

    if (global_state.prodotto == 3) {
      payload = {
        ...payload,
        TipoFiliali: 1,
      };
    }

    apiInvoker.DisponibilitaFiliale(payload, disp => {
      const disponibilita = disp.data;

      utils.sortAvailableHours(disponibilita.orariDisponibili);
      self.props.setDisponibilita(disponibilita);
      self.syncState();
    });
    var filiali_sel = self.state.filiali_selezionate.slice(0);
    if (filiali_sel.indexOf(id) == -1) {
      filiali_sel.push(id)
      this.setState({
        "filiali_selezionate": filiali_sel
      });
    } else {
      filiali_sel.splice(self.state.filiali_selezionate.indexOf(id), 1);
      this.setState({
        "filiali_selezionate": filiali_sel
      });
    }
  }
  setDataAndGo(orario, event) {
    let self = this;
    let elem = event.target;
    let box_filiale = elem.closest(".filiale-box");
    let id = box_filiale.getAttribute("id_filiale");
    let nome = box_filiale.getAttribute("nome");
    let indirizzo = box_filiale.getAttribute("indirizzo");
    if (orario.disponibile) {
      self.props.setOrario(orario.orario);
      self.props.setFiliale({
        'id': id,
        'nome': nome,
        'indirizzo': indirizzo,
      });

      handleFlow();
    }
  }
  getDisponibilita(disp) {
    let ret = [];
    if (disp) {
      for (let z = 0; z < disp.length; z++) {
        let cur_disp = disp[z];
        const global_state = utils.getState();
        let giorno_richiesto = moment(global_state.data_appuntamento).format('YYYY-MM-DD');
        for (let i = 0; i < cur_disp.orariDisponibili.length; i++) {
          let giorno_corrente = moment(cur_disp.giorno).format('YYYY-MM-DD');
          if (giorno_richiesto == giorno_corrente) {
            ret = cur_disp.orariDisponibili;
          }
        }
      }
    }
    return ret;
  }

  toggleFiliale = (idFiliale) => {
    const { filiali_selezionate } = this.state;
    
    if (idFiliale && filiali_selezionate && filiali_selezionate.indexOf(idFiliale) !== -1) {
      return true;
    }

    return false;
  }

  renderBoxFiliale = (filiale, index) => {
    return (
      <BoxFiliale
        key={ index }
        branch={ filiale }
        isOpen={ this.toggleFiliale(filiale.idFiliale) }
        openedMap={this.state.mappa_aperta}
        functions={
          {
            setDataAndGo: this.setDataAndGo,
            apriFiliale: this.apriFiliale,
            filialeHasData: this.filialeHasData,
            getDisponibilita: this.getDisponibilita,
            openMap: this.openMap,
          }
        }
      />
    );
  }

  renderFilialiList = (filiali) => {
    const reduxState = utils.getState();

    if (filiali && filiali.length) {  
      const boxFiliali = filiali.map((filiale, index) => {
        if (
          filiale.chiusuraStraordinaria
          || (reduxState.flusso_modifica == true && reduxState.dati_locali.vecchio_appuntamento.id_filiale!=filiale.idFiliale)
        ) {
          return false;
        }
  
        return this.renderBoxFiliale(filiale, index);
      })
  
      return boxFiliali;
    }

    return false;
  }

  render() {
    let gState = utils.getState();
    let recapAreaVisibility = false;
    let mostraVisible = true;
    if (gState.prodotto == 3) {
      recapAreaVisibility = true;
    }
    if (gState.prodotto == 3 && gState.flusso_modifica==true) {
      mostraVisible = false;
    }

    return (
      <div>
        <Stepper percentage="60" />
        <ModalError />
        <div id="filiale" className="grid-container">
          <RecapArea visible={ recapAreaVisibility } />
          <section className="animations-container">
            <h2 className="hasSubtitle gsap-fade">Scegli { gState.prodotto == 3 ? 'l\'agenzia' : 'la filiale' } e l'orario che preferisci:</h2>
            <CTA />
            {
              this.props.filiali ? this.renderFilialiList(this.props.filiali.filiali) : (<Spinner visible={true} />)
            }
            <div className="regolatore">
              {(mostraVisible) ? <button id="piu-filiali" className={'underlined' + ' ' + (this.state.filiali_total.length == 0 || gState.prodotto === 3 ? 'hidden' : '')} onClick={this.renderAltreFiliali.bind(this)}>
                Mostra altre filiali
              </button> : ''}
            </div>
          </section>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Filiale);


// WEBPACK FOOTER //
// ./src/components/filiale/index.js